import { useEffect, useState } from "react";
import { BookOpen, MapPin, Clock } from "lucide-react";
import api from "@/lib/api";

const DEFAULTS = {
  eyebrow: "Bibliothèque physique",
  title: "Bibliothèque centrale",
  banner_image: "/media/library-shelves.jpg",
  intro:
    "La Bibliothèque centrale de l'UNISIC met à disposition des étudiants et enseignants un fonds documentaire riche couvrant les sciences de l'information et de la communication, les sciences humaines, les langues et l'audiovisuel.",
  collections: "• Ouvrages spécialisés en communication et journalisme\n• Périodiques et revues scientifiques\n• Mémoires et thèses défendus à l'UNISIC\n• Ouvrages généraux en sciences humaines",
  hours: "Lundi au vendredi : 8h00 – 17h00\nSamedi : 9h00 – 13h00\nDimanche : fermé",
  address: "Campus UNISIC, Kinshasa, RD Congo",
};

export default function BibliothequeCentrale() {
  const [content, setContent] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/content/bm.bibliotheque_centrale").then((r) => setContent({ ...DEFAULTS, ...(r.data || {}) })).catch(() => {});
  }, []);
  return (
    <div data-testid="bib-centrale-page">
      <section className="relative h-[42vh] min-h-[300px] overflow-hidden">
        <img src={content.banner_image} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-veil" />
        <div className="relative h-full mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col justify-end pb-12">
          <div className="eyebrow" style={{ color: "#E5C158" }}>{content.eyebrow}</div>
          <h1 className="mt-3 text-white text-4xl sm:text-5xl font-bold tracking-tight">{content.title}</h1>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-unisic-gold" />
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            <div className="eyebrow eyebrow-dark">Présentation</div>
            <span className="divider-gold mt-3" />
            <p className="mt-6 text-lg text-slate-700 leading-relaxed whitespace-pre-line">{content.intro}</p>

            <div className="mt-10">
              <h3 className="text-xl font-bold text-unisic-blue flex items-center gap-2"><BookOpen className="w-5 h-5 text-unisic-gold" /> Collections</h3>
              <p className="mt-4 text-sm text-slate-700 leading-relaxed whitespace-pre-line">{content.collections}</p>
            </div>
          </div>
          <aside className="space-y-4">
            <div className="paper-card p-6">
              <div className="eyebrow eyebrow-dark flex items-center gap-2"><Clock className="w-3.5 h-3.5" /> Horaires</div>
              <span className="divider-gold mt-2" />
              <p className="mt-4 text-sm text-slate-700 whitespace-pre-line">{content.hours}</p>
            </div>
            <div className="paper-card p-6">
              <div className="eyebrow eyebrow-dark flex items-center gap-2"><MapPin className="w-3.5 h-3.5" /> Adresse</div>
              <span className="divider-gold mt-2" />
              <p className="mt-4 text-sm text-slate-700 whitespace-pre-line">{content.address}</p>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
